import { render, staticRenderFns } from "./ClienteTelefones.vue?vue&type=template&id=2d83727e"
import script from "./ClienteTelefones.vue?vue&type=script&lang=js"
export * from "./ClienteTelefones.vue?vue&type=script&lang=js"
import style0 from "./ClienteTelefones.vue?vue&type=style&index=0&id=2d83727e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports